import axios from 'axios';
import { errorsInterceptor } from './interceptor';

const API_HEADERS = {};

API_HEADERS['X-Requested-With'] = 'XMLHttpRequest';
API_HEADERS['Access-Control-Allow-Origin'] = true;
API_HEADERS['Cache-Control'] = 'no-cache, no-store, must-revalidate';
API_HEADERS.Pragma = 'no-cache';
API_HEADERS.Expires = '0';

const API = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: API_HEADERS,
  timeout: 10000,
  withCredentials: true,
});

errorsInterceptor(API);

export default API;
